import React from 'react'

import { createBrowserRouter, 
 createRoutesFromElements,
  Route, 
  RouterProvider
} from 'react-router-dom'
import Home from './components/pages/HomePage/Home'
import Destination from './components/pages/Destination/Destination'
import Crew from './components/pages/Crew/Crew'
import Technology from './components/pages/Technology/Technology'
import RootLayout from './layout/RootLayout'
import NotFound from './layout/NotFound'


const route = createBrowserRouter(
  createRoutesFromElements(
    <Route path='/' element={<RootLayout />}>
    <Route index element={<Home />} />
    <Route path='destination' element={<Destination />} />
    <Route path='crew' element={<Crew />} />
    <Route path='technology' element={<Technology />} />

    <Route path='*' element={<NotFound />}/>
   </Route>
  )
)
function App() {
  return (
    <>
  <RouterProvider router={route} />
    </>
  );
}

export default App;
